<template>
  <article
    class="bg-white border shadow-lg rounded-2xl px-4 py-6 xl:py-8 xl:px-10 mb-8"
  >
    <h3 class="text-text-blue font-semibold xl:text-lg mb-5">
      Servicios adicionales
      <span
        @click.prevent="changeStatusForm"
        class="font-normal text-sm text-mainOrange cursor-pointer"
        >{{ hideForm ? "(Ver más)" : "(Ver menos)" }}</span
      >
    </h3>

    <span v-for="data in dataServicios" :key="data">
      <div
        @click.prevent="changeServicioExtra(data)"
        :class="
          serviciosElegidos.find((value) => value.id === data.id)
            ? 'ring-mainGreenLight'
            : 'ring-gray-100'
        "
        class="tooltip no-underline hover:no-underline grid grid-cols-8 xl:grid-cols-7 items-center py-6 px-5 mb-6 shadow-md rounded-2xl cursor-pointer ring hover:ring-mainGreenLight transition-colors"
      >
        <div
          :class="
            serviciosElegidos.find((value) => value.id === data.id)
              ? 'border-mainGreenLight'
              : 'border-gray-light'
          "
          class="col-span-5 xl:col-span-5 pr-5 border-r"
        >
          <p class="mb-2 font-bold text-xs xl:text-base flex items-center gap-3">
            <img :src="data.img" alt="" />
            {{ data.name }}

            <span class="tooltip flex items-center">
              <img
                src="../../../assets/icons/icon-question.svg"
                alt="Info"
                class="w-4 h-4"
              />
              <span class="tooltip-box">
                {{ data.id === 1
                  ? 'Incluye evidencia visual. No pruebas técnicas.'
                  : data.id === 3
                    ? 'Costos de courier/etiqueta pueden aplicar según tienda.'
                    : ''
                }}
              </span>

            </span>
          </p>

          <p
            v-if="!hideForm"
            class="text-xs xl:text-sm font-medium xl:leading-6"
          >
            {{ data.detail }}
          </p>
        </div>
        <div
          class="col-span-3 xl:col-span-2 font-bold pl-2 xl:pl-6 xl:pr-2 mx-auto"
        >
          <p
            :class="!hideForm ? 'mb-5' : 'mb-3'"
            class="text-center text-xs xl:text-base"
          >
            <span class="text-mainOrange">USD</span>
            {{ data.type === 1 ? data.newCost : data.cost }}
          </p>
          <span
            :class="
              serviciosElegidos.find((value) => value.id === data.id)
                ? 'ring-mainGreenLight bg-mainGreenLight'
                : 'bg-gray-light ring-gray-light'
            "
            class="flex items-center justify-center mx-auto w-4 h-4 rounded-sm ring ring-offset-2"
          >
            <img
              src="../../../assets/icons/check-white.svg"
              class="w-3 h-auto"
              v-if="serviciosElegidos.find((value) => value.id === data.id)"
            />
          </span>
        </div>
        <span v-if="hideForm" class="tooltip-box bottom-24">{{
          data.detail
        }}</span>
      </div>
    </span>
  </article>
</template>
<script>
//Importando serve
import { server } from "../../../config/global";
const BASE_URL = server.API_URL;
//Importando librerias
import axios from "axios";
export default {
  data() {
    return {
      hideForm: false,
      dataServicios: [],
      serviciosElegidos: [],
    };
  },
  mounted() {
    this.getServicio();
  },
  methods: {
    changeServicioExtra(value) {
      if (value !== 0) {
        var evitarDuplicados = this.serviciosElegidos.find(function (item) {
          if (item.id === value.id) {
            return item;
          }
        });
        if (!evitarDuplicados) {
          this.serviciosElegidos.push(value);
        }
        if (evitarDuplicados) {
          var idServiceRpetido = evitarDuplicados.id;
          this.serviciosElegidos = this.serviciosElegidos.filter(
            (el) => el.id !== idServiceRpetido
          );
        }
      }
      this.$store.state.servicioElegido = this.serviciosElegidos;

      //hallamos el total en dolares
      var totalDolares = 0.0;

      this.serviciosElegidos.forEach((value) => {
        if (value.type === 0) {
          totalDolares = totalDolares + value.cost;
        }
        if (value.type === 1) {
          totalDolares = totalDolares + value.newCost;
        }
      });

      var result1 = Math.floor(totalDolares * 100) / 100;
      this.$store.state.servicePrecioDolares = parseFloat(result1.toFixed(2));

      //hallamos el total en soles
      var totalSoles = 0.0;

      this.serviciosElegidos.forEach((value) => {
        if (value.type === 0) {
          totalSoles = totalSoles + value.local_amount;
        }
        if (value.type === 1) {
          totalSoles = totalSoles + value.newCostSoles;
        }
      });
      var result2 = Math.floor(totalSoles * 100) / 100;
      this.$store.state.servicePrecioSoles = parseFloat(result2.toFixed(2));
    },
    async getServicio() {
      await axios
        .get(`${BASE_URL}` + "servicesExtras/getList/1")
        .then((response) => {
          this.dataServicios = response.data.body;
          this.changeDataService();
        })
        .catch((error) => {
          if (error) {
            //----------component--------//
            this.$store.state.alert.titulo = "Error";
            this.$store.state.alert.description =
              "Error al obtener los servicios extras";
            this.$store.state.alert.estado = true;
            //--------------------------//
          }
        });
    },
    changeDataService() {
      this.dataServicios.forEach((value) => {
        if (value.type === 1) {
          var porcentajeProduct =
            this.getServicioProductPrice * (value.cost / 100);
          porcentajeProduct = Math.ceil(100 * porcentajeProduct) / 100;
          if (porcentajeProduct < 5) {
            porcentajeProduct = 5;
          }
          porcentajeProduct = porcentajeProduct + 5;
          value.newCost = Math.ceil(100 * porcentajeProduct) / 100;
          var newCostSoles = porcentajeProduct * value.exchange_rate;
          value.newCostSoles = Math.ceil(100 * newCostSoles) / 100;
        }
      });
    },
    changeStatusForm() {
      this.hideForm = !this.hideForm;
    },
  },
  computed: {
    getServicioElegido() {
      return this.$store.state.servicioElegido;
    },
    getServicioProductPrice() {
      return this.$store.state.servicePrecioProduct;
    },
  },
  watch: {
    getServicioProductPrice: function () {
      this.changeDataService();
      if (this.getServicioElegido.length !== 0) {
        this.changeServicioExtra(0);
      }
    },
  },
};
</script>
